module.exports = __webpack_public_path__ + "static/img/5.eceaf3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/zh/5.png
// module id = 7D6L
// module chunks = 0